//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_APP_VERSION_LIST = 'SET_APP_VERSION_LIST';
export const CLEAR_APP_VERSION_LIST = 'CLEAR_APP_VERSION_LIST';
export const APP_VERSION_LIST_PENDING = 'APP_VERSION_LIST_PENDING';
export const APP_VERSION_LIST_ERROR = 'APP_VERSION_LIST_ERROR';
export const APP_VERSION_LIST_ERROR_CLEAR = 'APP_VERSION_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const APP_VERSION_FILTER_DIALOG_OPEN = 'APP_VERSION_FILTER_DIALOG_OPEN';
export const APP_VERSION_FILTER_DIALOG_CLOSE = 'APP_VERSION_FILTER_DIALOG_CLOSE';
export const SET_APP_VERSION_FILTER_DATA = 'SET_APP_VERSION_FILTER_DATA';

//-----------------------------|| DETAILS ||------------------------------------------------------------
export const SET_APP_VERSION_DETAILS = 'SET_APP_VERSION_DETAILS';
export const CLEAR_APP_VERSION_DETAILS = 'CLEAR_APP_VERSION_DETAILS';
export const APP_VERSION_DETAIL_PENDING = 'APP_VERSION_DETAIL_PENDING';

//-----------------------------|| CREATE ||-------------------------------------------------------------
export const APP_VERSION_CREATE_DIALOG_OPEN = 'APP_VERSION_CREATE_DIALOG_OPEN';
export const APP_VERSION_CREATE_DIALOG_CLOSE = 'APP_VERSION_CREATE_DIALOG_CLOSE';
export const APP_VERSION_CREATE_PENDING = 'APP_VERSION_CREATE_PENDING';
export const APP_VERSION_CREATE_ERROR = 'APP_VERSION_CREATE_ERROR';
export const APP_VERSION_CREATE_ERROR_CLEAR = 'APP_VERSION_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const APP_VERSION_EDIT_DIALOG_OPEN = 'APP_VERSION_EDIT_DIALOG_OPEN';
export const APP_VERSION_EDIT_DIALOG_CLOSE = 'APP_VERSION_EDIT_DIALOG_CLOSE';
export const APP_VERSION_EDIT_PENDING = 'APP_VERSION_EDIT_PENDING';
export const APP_VERSION_EDIT_ERROR = 'APP_VERSION_EDIT_ERROR';
export const APP_VERSION_EDIT_ERROR_CLEAR = 'APP_VERSION_EDIT_ERROR_CLEAR';